/*
 * @description:
 * @Author: xinliu
 * @Date: 2022-03-18 10:09:22
 * @LastEditors: xinliu
 * @LastEditTime: 2022-03-18 14:34:01
 */
import CustomForm from "./CustomForm.vue";
const components = {
  install(Vue) {
    Vue.component("CustomForm", CustomForm);
  },
};
if (typeof window !== "undefined" && window.Vue) {
  window.Vue.use(components);
}
export default components;



// WEBPACK FOOTER //
// ./src/index.js